(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[93981,99965],{

/***/ 35229:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.l = function FaCheck (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"}}]})(props);
};


/***/ }),

/***/ 44147:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.G = function FaTimesCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"}}]})(props);
};


/***/ }),

/***/ 80297:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.H = function HiExclamation (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z","clipRule":"evenodd"}}]})(props);
};


/***/ }),

/***/ 32757:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.V = function HiXCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z","clipRule":"evenodd"}}]})(props);
};


/***/ }),

/***/ 31532:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.e = function RiShieldCheckFill (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"fill":"none","d":"M0 0H24V24H0z"}},{"tag":"path","attr":{"d":"M12 1l8.217 1.826c.457.102.783.507.783.976v9.987c0 2.006-1.003 3.88-2.672 4.992L12 23l-6.328-4.219C4.002 17.668 3 15.795 3 13.79V3.802c0-.469.326-.874.783-.976L12 1zm4.452 7.222l-4.95 4.949-2.828-2.828-1.414 1.414L11.503 16l6.364-6.364-1.415-1.414z"}}]}]})(props);
};


/***/ }),

/***/ 12329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tr; }
});

;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/tr/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'bir saniyeden az',
    other: '{{count}} saniyeden az'
  },
  xSeconds: {
    one: '1 saniye',
    other: '{{count}} saniye'
  },
  halfAMinute: 'yarım dakika',
  lessThanXMinutes: {
    one: 'bir dakikadan az',
    other: '{{count}} dakikadan az'
  },
  xMinutes: {
    one: '1 dakika',
    other: '{{count}} dakika'
  },
  aboutXHours: {
    one: 'yaklaşık 1 saat',
    other: 'yaklaşık {{count}} saat'
  },
  xHours: {
    one: '1 saat',
    other: '{{count}} saat'
  },
  xDays: {
    one: '1 gün',
    other: '{{count}} gün'
  },
  aboutXWeeks: {
    one: 'yaklaşık 1 hafta',
    other: 'yaklaşık {{count}} hafta'
  },
  xWeeks: {
    one: '1 hafta',
    other: '{{count}} hafta'
  },
  aboutXMonths: {
    one: 'yaklaşık 1 ay',
    other: 'yaklaşık {{count}} ay'
  },
  xMonths: {
    one: '1 ay',
    other: '{{count}} ay'
  },
  aboutXYears: {
    one: 'yaklaşık 1 yıl',
    other: 'yaklaşık {{count}} yıl'
  },
  xYears: {
    one: '1 yıl',
    other: '{{count}} yıl'
  },
  overXYears: {
    one: '1 yıldan fazla',
    other: '{{count}} yıldan fazla'
  },
  almostXYears: {
    one: 'neredeyse 1 yıl',
    other: 'neredeyse {{count}} yıl'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + ' sonra';
    } else {
      return result + ' önce';
    }
  }
  return result;
};
/* harmony default export */ var _lib_formatDistance = (formatDistance);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
var buildFormatLongFn = __webpack_require__(49526);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/tr/_lib/formatLong/index.js

var dateFormats = {
  full: 'd MMMM y EEEE',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'dd.MM.yyyy'
};
var timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats = {
  full: "{{date}} 'saat' {{time}}",
  long: "{{date}} 'saat' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/tr/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'geçen hafta' eeee 'saat' p",
  yesterday: "'dün saat' p",
  today: "'bugün saat' p",
  tomorrow: "'yarın saat' p",
  nextWeek: "eeee 'saat' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
/* harmony default export */ var _lib_formatRelative = (formatRelative);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
var buildLocalizeFn = __webpack_require__(88486);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/tr/_lib/localize/index.js

var eraValues = {
  narrow: ['MÖ', 'MS'],
  abbreviated: ['MÖ', 'MS'],
  wide: ['Milattan Önce', 'Milattan Sonra']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1Ç', '2Ç', '3Ç', '4Ç'],
  wide: ['İlk çeyrek', 'İkinci Çeyrek', 'Üçüncü çeyrek', 'Son çeyrek']
};
var monthValues = {
  narrow: ['O', 'Ş', 'M', 'N', 'M', 'H', 'T', 'A', 'E', 'E', 'K', 'A'],
  abbreviated: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
  wide: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık']
};
var dayValues = {
  narrow: ['P', 'P', 'S', 'Ç', 'P', 'C', 'C'],
  short: ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'],
  abbreviated: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cts'],
  wide: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi']
};
var dayPeriodValues = {
  narrow: {
    am: 'öö',
    pm: 'ös',
    midnight: 'gy',
    noon: 'ö',
    morning: 'sa',
    afternoon: 'ös',
    evening: 'ak',
    night: 'ge'
  },
  abbreviated: {
    am: 'ÖÖ',
    pm: 'ÖS',
    midnight: 'gece yarısı',
    noon: 'öğle',
    morning: 'sabah',
    afternoon: 'öğleden sonra',
    evening: 'akşam',
    night: 'gece'
  },
  wide: {
    am: 'Ö.Ö.',
    pm: 'Ö.S.',
    midnight: 'gece yarısı',
    noon: 'öğle',
    morning: 'sabah',
    afternoon: 'öğleden sonra',
    evening: 'akşam',
    night: 'gece'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'öö',
    pm: 'ös',
    midnight: 'gy',
    noon: 'ö',
    morning: 'sa',
    afternoon: 'ös',
    evening: 'ak',
    night: 'ge'
  },
  abbreviated: {
    am: 'ÖÖ',
    pm: 'ÖS',
    midnight: 'gece yarısı',
    noon: 'öğlen',
    morning: 'sabahleyin',
    afternoon: 'öğleden sonra',
    evening: 'akşamleyin',
    night: 'geceleyin'
  },
  wide: {
    am: 'ö.ö.',
    pm: 'ö.s.',
    midnight: 'gece yarısı',
    noon: 'öğlen',
    morning: 'sabahleyin',
    afternoon: 'öğleden sonra',
    evening: 'akşamleyin',
    night: 'geceleyin'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + '.';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: (0,buildLocalizeFn/* default */.Z)({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,buildLocalizeFn/* default */.Z)({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: (0,buildLocalizeFn/* default */.Z)({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: (0,buildLocalizeFn/* default */.Z)({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0,buildLocalizeFn/* default */.Z)({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var _lib_localize = (localize);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
var buildMatchFn = __webpack_require__(76723);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
var buildMatchPatternFn = __webpack_require__(60974);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/tr/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(mö|ms)/i,
  abbreviated: /^(mö|ms)/i,
  wide: /^(milattan önce|milattan sonra)/i
};
var parseEraPatterns = {
  any: [/(^mö|^milattan önce)/i, /(^ms|^milattan sonra)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]ç/i,
  wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
  abbreviated: [/1ç/i, /2ç/i, /3ç/i, /4ç/i],
  wide: [/^(i|İ)lk çeyrek/i, /(i|İ)kinci çeyrek/i, /üçüncü çeyrek/i, /son çeyrek/i]
};
var matchMonthPatterns = {
  narrow: /^[oşmnhtaek]/i,
  abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
  wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
};
var parseMonthPatterns = {
  narrow: [/^o/i, /^ş/i, /^m/i, /^n/i, /^m/i, /^h/i, /^t/i, /^a/i, /^e/i, /^e/i, /^k/i, /^a/i],
  any: [/^o/i, /^ş/i, /^mar/i, /^n/i, /^may/i, /^h/i, /^t/i, /^ağ/i, /^ey/i, /^ek/i, /^k/i, /^ar/i]
};
var matchDayPatterns = {
  narrow: /^[psçc]/i,
  short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
  abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
  wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
};
var parseDayPatterns = {
  narrow: [/^p/i, /^p/i, /^s/i, /^ç/i, /^p/i, /^c/i, /^c/i],
  any: [/^pz/i, /^pt/i, /^sa/i, /^ça/i, /^pe/i, /^cu/i, /^ct/i],
  wide: [/^pazar(?!tesi)/i, /^pazartesi/i, /^salı/i, /^çarşamba/i, /^perşembe/i, /^cuma(?!rtesi)/i, /^cumartesi/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
  any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^ö\.?ö\.?/i,
    pm: /^ö\.?s\.?/i,
    midnight: /^(gy|gece yarısı)/i,
    noon: /^öğ/i,
    morning: /^sa/i,
    afternoon: /^öğleden sonra/i,
    evening: /^ak/i,
    night: /^ge/i
  }
};
var match = {
  ordinalNumber: (0,buildMatchPatternFn/* default */.Z)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var _lib_match = (match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/tr/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary Turkish locale.
 * @language Turkish
 * @iso-639-2 tur
 * @author Alpcan Aydın [@alpcanaydin]{@link https://github.com/alpcanaydin}
 * @author Berkay Sargın [@berkaey]{@link https://github.com/berkaey}
 * @author Fatih Bulut [@bulutfatih]{@link https://github.com/bulutfatih}
 * @author Ismail Demirbilek [@dbtek]{@link https://github.com/dbtek}
 * @author İsmail Kayar [@ikayar]{@link https://github.com/ikayar}
 *
 *
 */
var locale = {
  code: 'tr',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var tr = (locale);

/***/ }),

/***/ 92235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);




var FancyBox = function(param) {
    var children = param.children, _options = param.options, options = _options === void 0 ? {} : _options, _delegate = param.delegate, delegate = _delegate === void 0 ? "[data-fancybox]" : _delegate;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), scriptsLoaded = ref[0], setScriptsLoaded = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var loadFancybox = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var link;
                return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            // Add CSS
                            if (!document.querySelector('link[href*="fancybox.css"]')) {
                                link = document.createElement("link");
                                link.rel = "stylesheet";
                                link.href = "https://cdn.jsdelivr.net/npm/@fancyapps/ui@5/dist/fancybox/fancybox.css";
                                document.head.appendChild(link);
                            }
                            if (document.querySelector('script[src*="fancybox.umd.js"]')) {
                                _ctx.next = 3;
                                break;
                            }
                            return _ctx.abrupt("return", new Promise(function(resolve) {
                                var script = document.createElement("script");
                                script.src = "https://cdn.jsdelivr.net/npm/@fancyapps/ui@5/dist/fancybox/fancybox.umd.js";
                                script.async = true;
                                script.onload = function() {
                                    return resolve(true);
                                };
                                document.body.appendChild(script);
                            }));
                        case 3:
                            return _ctx.abrupt("return", Promise.resolve(true));
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function loadFancybox() {
                return _ref.apply(this, arguments);
            };
        }();
        loadFancybox().then(function() {
            setScriptsLoaded(true);
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (scriptsLoaded && window.Fancybox) {
            // Initialize Fancybox
            window.Fancybox.bind(delegate, options);
            // Cleanup function
            return function() {
                window.Fancybox.destroy();
            };
        }
    }, [
        scriptsLoaded,
        delegate,
        options
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: children
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FancyBox);


/***/ }),

/***/ 4550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Pages_Reservation; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/Detail/Icons.js
var Icons = __webpack_require__(80103);
// EXTERNAL MODULE: ./components/LoaderRemote.js
var LoaderRemote = __webpack_require__(71593);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(84849);
;// CONCATENATED MODULE: ./components/Reservation/Title.js


var Title = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "font-semibold text-lg text-primary",
        children: children
    });
};
/* harmony default export */ var Reservation_Title = (Title);

;// CONCATENATED MODULE: ./components/FastReservation/FormRadio.js


var FormRadio = function(param) {
    var name = param.name, value = param.value, text = param.text, content = param.content, paymentType = param.paymentType, setpaymentType = param.setpaymentType, _width = param.width, width = _width === void 0 ? "sm:w-1/2" : _width;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(width, " pl-6 pr-11 sm:h-24 py-5 sm:py-0 sm:first:border-r-2 border-['#EFF5F7']"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
            className: "flex items-center h-full cursor-pointer relative pl-9",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "radio",
                    className: "w-0 h-0",
                    name: name,
                    value: value,
                    onChange: function(e) {
                        return setpaymentType(value);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "font-medium text-15",
                    children: text
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "w-6 h-6 rounded-full border-[3px] absolute left-0 flex items-center justify-center before:content[''] before:w-2 before:h-2 before:bg-primary before:inline-block before:rounded-full before:transition before:transform   " + (paymentType == value ? "before:scale-1" : "before:scale-0")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "font-semibold text-xl  ml-auto " + (paymentType == value ? "text-primary opacity-100" : "text-black opacity-25"),
                    children: content
                })
            ]
        })
    });
};
/* harmony default export */ var FastReservation_FormRadio = (FormRadio);

// EXTERNAL MODULE: ./components/DefaultCurrencyFormat.js
var DefaultCurrencyFormat = __webpack_require__(16543);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./context/context.js
var context = __webpack_require__(94268);
// EXTERNAL MODULE: ./context/TranslationContext.js
var TranslationContext = __webpack_require__(73040);
;// CONCATENATED MODULE: ./components/Reservation/FirstPayment.js








var FirstPayment = function(param) {
    var reservationResult = param.reservationResult, payment_type = param.payment_type;
    var ref = (0,TranslationContext/* useTranslation */.m)(), depositPrice = ref.depositPrice, reservationPaymentAll = ref.reservationPaymentAll;
    var page = (0,react.useContext)(context/* StoreContext */.x).page;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,formik_esm/* useField */.U$)("firstPayment"), 3), field = ref1[0], meta = ref1[1], helpers = ref1[2];
    var initialValue = payment_type == "all" ? 2 : 1;
    var ref2 = (0,react.useState)(initialValue), paymentType = ref2[0], setpaymentType = ref2[1];
    (0,react.useEffect)(function() {
        helpers.setValue(paymentType);
    }, [
        paymentType
    ]);
    var width = payment_type == "default" ? "w-1/2" : "w-full";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex border-b-2 border-['#EFF5F7'] flex-col sm:flex-row",
        children: reservationResult.success && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                payment_type !== "all" && /*#__PURE__*/ (0,jsx_runtime.jsx)(FastReservation_FormRadio, {
                    name: "payment",
                    value: "1",
                    width: width,
                    text: depositPrice + " (%" + page.Product.depozito + ")",
                    paymentType: paymentType,
                    setpaymentType: setpaymentType,
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                        value: reservationResult.result.deposit_price,
                        Symbol: reservationResult.result.symbol
                    })
                }),
                payment_type !== "advance" && /*#__PURE__*/ (0,jsx_runtime.jsx)(FastReservation_FormRadio, {
                    name: "payment",
                    value: "2",
                    width: width,
                    text: reservationPaymentAll,
                    paymentType: paymentType,
                    setpaymentType: setpaymentType,
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                        value: reservationResult.result.accommodation_fee,
                        Symbol: reservationResult.result.symbol
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Reservation_FirstPayment = (FirstPayment);

// EXTERNAL MODULE: ./icons/icons.js
var icons = __webpack_require__(17601);
;// CONCATENATED MODULE: ./components/Reservation/PaymentMethod.js






var PaymentMethod = function() {
    var ref = (0,TranslationContext/* useTranslation */.m)(), paymentMethod1Title = ref.paymentMethod1Title, paymentMethod2Title = ref.paymentMethod2Title, paymentMethod1Description = ref.paymentMethod1Description, paymentMethod2Description = ref.paymentMethod2Description;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,formik_esm/* useField */.U$)("paymentMethod"), 3), field = ref1[0], meta = ref1[1], helpers = ref1[2];
    var ref2 = (0,react.useState)(meta.initialValue), payment = ref2[0], setPayment = ref2[1];
    (0,react.useEffect)(function() {
        helpers.setValue(payment);
    }, [
        payment
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex sm:h-44 items-center flex-col sm:flex-row gap-y-4 py-5 sm:py-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-6 sm:w-1/2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                    className: "relative flex pl-11 items-center cursor-pointer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "radio",
                            className: "w-0 h-0",
                            name: "payment",
                            value: "1",
                            onChange: function(e) {
                                return setPayment(1);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "w-6 h-6 rounded-full border-[3px] absolute left-0 top-3 flex items-center justify-center before:content[''] before:w-2 before:h-2 before:bg-primary before:inline-block before:rounded-full before:transition before:transform   " + (payment == "1" ? "before:scale-1" : "before:scale-0")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "self-start mt-0.5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                                name: "PaymentOption1"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col ml-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mb-2 text-15",
                                    children: paymentMethod1Title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-13 text-brand-gray-9 -mt-1",
                                    children: paymentMethod1Description
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-6 sm:w-1/2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                    className: "relative flex pl-11 items-center cursor-pointer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "radio",
                            className: "w-0 h-0",
                            name: "payment",
                            value: "2",
                            onChange: function(e) {
                                return setPayment(2);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "w-6 h-6 rounded-full border-[3px] absolute left-0 top-3 flex items-center justify-center before:content[''] before:w-2 before:h-2 before:bg-primary before:inline-block before:rounded-full before:transition before:transform   " + (payment == "2" ? "before:scale-1" : "before:scale-0")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "self-start mt-0.5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                                name: "PaymentOption2"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col ml-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mb-2 text-15",
                                    children: paymentMethod2Title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-13 text-brand-gray-9 -mt-1",
                                    children: paymentMethod2Description
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Reservation_PaymentMethod = (PaymentMethod);

;// CONCATENATED MODULE: ./components/Reservation/PaymentOptions.js






var PaymentOptions = function(param) {
    var reservationResult = param.reservationResult, paymentType = param.paymentType;
    var reservationSection2Title = (0,TranslationContext/* useTranslation */.m)().reservationSection2Title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Reservation_Title, {
                children: reservationSection2Title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-5 bg-white rounded-md shadow-[0_22px_24px_0_rgba(226,236,240,0.13)]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Reservation_FirstPayment, {
                        reservationResult: reservationResult,
                        payment_type: paymentType
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Reservation_PaymentMethod, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var Reservation_PaymentOptions = (PaymentOptions);

// EXTERNAL MODULE: ./components/FastReservation.js + 14 modules
var FastReservation = __webpack_require__(98555);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/yup-locales/dist/yup-locales.esm.js
var yup_locales_esm = __webpack_require__(18700);
;// CONCATENATED MODULE: ./validations/ReservationShema.js


if (true) es/* setLocale */.i_(yup_locales_esm.tr); // en: Yup varsayilan (Ingilizce) mesajlari
var ReservationShema = es/* object */.Ry().shape({
    name: es/* string */.Z_().required().min(2),
    email: es/* string */.Z_().required().email(),
    phoneIsValid: es/* boolean */.O7().isTrue(),
    phoneIsValid2: es/* boolean */.O7(),
    // identityNumber: Yup.string().required(),
    firstPayment: es/* number */.Rx(),
    paymentMethod: es/* number */.Rx(),
    sozlesme: es/* boolean */.O7().isTrue(),
    kvkk: es/* boolean */.O7().isTrue()
});

;// CONCATENATED MODULE: ./validations/index.js


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./components/Reservation/TextInput.js






var TextInput = function(_param) {
    var label = _param.label, props = (0,_object_without_properties/* default */.Z)(_param, [
        "label"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,formik_esm/* useField */.U$)(props), 3), field = ref[0], meta = ref[1], helpers = ref[2];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative text-brand-gray-9 bg-white rounded-md shadow-[0_22px_24px_0_rgba(226,236,240,0.13)] px-9 flex items-center h-[70px] transition-all ".concat(!meta.error && meta.touched ? "border-2 border-green-400" : null, " ").concat(meta.error && meta.touched ? "border-2 border-red-400" : null, " "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({}, field, props)),
            props.isrequired && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: " absolute right-4 top-4",
                children: "*"
            })
        ]
    });
};
/* harmony default export */ var Reservation_TextInput = (TextInput);

// EXTERNAL MODULE: ./components/Reservation/PhoneInput.js
var PhoneInput = __webpack_require__(23515);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(22920);
// EXTERNAL MODULE: ./components/ErrorComp.js
var ErrorComp = __webpack_require__(91450);
;// CONCATENATED MODULE: ./components/Reservation/SendBtn.js






var getFieldErrorNames = function(formikErrors) {
    var transformObjectToDotNotation = function(obj) {
        var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", result = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
        Object.keys(obj).forEach(function(key) {
            var value = obj[key];
            if (!value) return;
            var nextKey = prefix ? "".concat(prefix, ".").concat(key) : key;
            if (typeof value === "object") {
                transformObjectToDotNotation(value, nextKey, result);
            } else {
                result.push(nextKey);
            }
        });
        return result;
    };
    return transformObjectToDotNotation(formikErrors);
};
var ScrollToFieldError = function() {
    var reservationSendValidationError = (0,TranslationContext/* useTranslation */.m)().reservationSendValidationError;
    var ref = (0,formik_esm/* useFormikContext */.u6)(), submitCount = ref.submitCount, isValid = ref.isValid, errors = ref.errors;
    (0,react.useEffect)(function() {
        if (isValid) return;
        var fieldErrorNames = getFieldErrorNames(errors);
        if (fieldErrorNames.length <= 0) return;
        var element = document.querySelector("input[name='".concat(fieldErrorNames[0], "']"));
        if (!element) return;
        // Scroll to first known error into view
        react_toastify_esm/* toast.error */.Am.error(reservationSendValidationError);
    }, [
        submitCount
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return null;
};
var SendBtn = function(param) {
    var a = param.a, reservationResult = param.reservationResult;
    var ref = (0,TranslationContext/* useTranslation */.m)(), reservationSendBtnText = ref.reservationSendBtnText, payNow = ref.payNow, creditCardInstantNote = ref.creditCardInstantNote;
    var ref1 = (0,react.useState)(false), isDisabled = ref1[0], setIsDisabled = ref1[1];
    var ref2 = (0,formik_esm/* useFormikContext */.u6)(), setFieldValue = ref2.setFieldValue, values = ref2.values;
    (0,react.useEffect)(function() {
        if (reservationResult.apiResponse) {
            if (reservationResult.error) setIsDisabled(true);
            else setIsDisabled(false);
        } else {
            setIsDisabled(false);
        }
    }, [
        reservationResult
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollToFieldError, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                disabled: a.isSubmitting || Object.keys(a.errors).length > 0 || isDisabled,
                type: "submit",
                onClick: function() {
                    setFieldValue("directly", reservationResult.BookableDirectly == "1" && values.paymentMethod == 2 ? 1 : 0);
                },
                className: " px-10 py-3 text-white font-poppins text-sm leading-9 bg-greenGra mt-6 disabled:opacity-60 disabled:cursor-not-allowed",
                children: reservationResult.BookableDirectly == "1" && values.paymentMethod == 2 ? payNow : reservationSendBtnText
            }),
            reservationResult.BookableDirectly == "1" && values.paymentMethod == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComp/* default */.Z, {
                type: "warning",
                children: creditCardInstantNote
            }) : ""
        ]
    });
};
/* harmony default export */ var Reservation_SendBtn = (SendBtn);

// EXTERNAL MODULE: ./components/Reservation/Contract.js
var Contract = __webpack_require__(57736);
// EXTERNAL MODULE: ./components/api.js
var api = __webpack_require__(9012);
// EXTERNAL MODULE: ./scripts/criteo.js
var criteo = __webpack_require__(77793);
// EXTERNAL MODULE: ./components/BackButton.js
var BackButton = __webpack_require__(70454);
// EXTERNAL MODULE: ./components/DiscountBannerMobile.js
var DiscountBannerMobile = __webpack_require__(22257);
// EXTERNAL MODULE: ./components/KiralaGelBanner.js
var KiralaGelBanner = __webpack_require__(14082);
;// CONCATENATED MODULE: ./components/Pages/Reservation/Index.js

























var Index = function(param) {
    var page = param.page, isAppWebView = param.isAppWebView, deviceType = param.deviceType;
    var ref;
    var ref1 = (0,TranslationContext/* useTranslation */.m)(), reservationSection1Title = ref1.reservationSection1Title, reservationFormNamePlaceholder = ref1.reservationFormNamePlaceholder, reservationFormEmailPlaceholder = ref1.reservationFormEmailPlaceholder, reservationFormPhonePlaceholder = ref1.reservationFormPhonePlaceholder, reservationFormPhonePlaceholder2 = ref1.reservationFormPhonePlaceholder2, reservationSection3Title = ref1.reservationSection3Title, reservationDamageDeposit = ref1.reservationDamageDeposit, reservationDamageDepositDescription = ref1.reservationDamageDepositDescription, reservationCheckinCheckoutTime = ref1.reservationCheckinCheckoutTime, reservationCheckinTime = ref1.reservationCheckinTime, reservationCheckoutTime = ref1.reservationCheckoutTime, inludedPrice = ref1.inludedPrice, contract1 = ref1.contract1, contract2 = ref1.contract2;
    var ref2 = (0,react.useState)(1), isLoading = ref2[0], setisLoading = ref2[1];
    var ref3 = (0,react.useState)(false), reservationResult = ref3[0], setreservationResult = ref3[1];
    var router = (0,next_router.useRouter)();
    var ref4 = (0,react.useState)(false), error = ref4[0], setError = ref4[1];
    var SuccessPage = page.SuccessPage;
    (0,react.useEffect)(function() {
        if (error) react_toastify_esm/* toast.error */.Am.error(error);
    }, [
        error
    ]);
    (0,react.useEffect)(function() {
        setisLoading(0);
    }, []);
    var setParam = function(obj) {
        var query = router.query;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], value = _value[1];
                query[key] = value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        query.slug = [
            page.url
        ];
        router.replace({
            query: query
        }, undefined, {
            scroll: false,
            shallow: true
        });
    };
    var SqlDate = function(d) {
        var a = d.split("-");
        return a[2] + "." + a[1] + "." + a[0];
    };
    var ref5 = (0,TranslationContext/* useTranslation */.m)(), reservationTitle = ref5.reservationTitle, person = ref5.person, bedRoom = ref5.bedRoom, bathRoom = ref5.bathRoom;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "bg-[#EFF5F7] pt-8 relative pb-44",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container flex flex-col items-start lg:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full lg:w-[300px] xl:w-[381px] mr-12 flex flex-col z-10 static lg:sticky top-1 ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton/* default */.Z, {
                                isAppWebView: isAppWebView
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative w-full h-52",
                                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    height: 207
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: page.Product.resim,
                                    loader: LoaderRemote/* default */.Z,
                                    alt: page.Product.title,
                                    objectFit: "cover",
                                    sizes: "(max-width: 1024px) 100vw, (max-width: 1280px) 300px, 400px",
                                    layout: "fill"
                                })
                            }),
                            !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(FastReservation["default"], {
                                setreservationResult: setreservationResult,
                                setParam: setParam,
                                id: page.Product.id,
                                kisi: page.Product.kisi,
                                paymentType: page === null || page === void 0 ? void 0 : (ref = page.Product) === null || ref === void 0 ? void 0 : ref.paymentType,
                                isAppWebView: isAppWebView,
                                deviceType: deviceType
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden lg:block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KiralaGelBanner/* default */.Z, {
                                    src: "/images/kiralagel-banner/575x260.png",
                                    deviceType: deviceType
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "z-0 flex-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-3 bg-white p-3 rounded-md text-center lg:text-left lg:mt-0 lg:bg-transparent lg:rounded-none lg:p-0 flex flex-col before:content-[''] before:absolute before:bg-white before:left-0 before:top-0 before:w-full before:h-60 before:-z-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "pt-[30px] pb-10 text-lg lg:text-2xl",
                                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                            height: 33
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            dangerouslySetInnerHTML: {
                                                __html: reservationTitle.replace("{baslik}", page.Product.baslik)
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: "bg-[#EDF0F2] h-0.5"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-col items-center mt-7 lg:flex-row",
                                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex-50",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                        height: 33
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "ml-auto",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                        height: 33,
                                                        width: 100
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-col items-center mb-5 lg:items-start lg:mb-0",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            className: "text-black text-[22px] lg:text-base xl:text-[22px]",
                                                            children: page.Product.baslik
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "flex md:mt-2 lg:mt-0",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "font-bold text-13 lg:text-sm opacity-50 !leading-none",
                                                                children: page.Product.destination
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex justify-between lg:ml-5 xl:ml-24 gap-x-4 lg:gap-x-14 mb-7 lg:mb-0",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex items-center justify-items-center ",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "iconsImgFilter",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* default */.Z, {
                                                                        name: "VillaItemProp1"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex flex-col ml-3 text-sm font-bold leading-4 text-brand-gray-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: page.Product.kisi
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: person
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex items-center justify-items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "iconsImgFilter",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* default */.Z, {
                                                                        name: "VillaItemProp2"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex flex-col ml-3 text-sm font-bold leading-4 text-brand-gray-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: page.Product.yatak_odasi
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: bedRoom
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex items-center justify-items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "iconsImgFilter",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* default */.Z, {
                                                                        name: "VillaItemProp3"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex flex-col ml-3 text-sm font-bold leading-4 text-brand-gray-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: page.Product.banyo
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: bathRoom
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                                initialValues: {
                                    name: "",
                                    email: "",
                                    phone: "",
                                    phoneIsValid: false,
                                    phone2: "",
                                    phoneIsValid2: false,
                                    identityNumber: "",
                                    firstPayment: 1,
                                    paymentMethod: (reservationResult === null || reservationResult === void 0 ? void 0 : reservationResult.BookableDirectly) == "1" ? 1 : 2,
                                    sozlesme: false,
                                    kvkk: false,
                                    directly: 0
                                },
                                validationSchema: ReservationShema,
                                onSubmit: function(values, actions) {
                                    (0,api/* SendReservation */._c)({
                                        EntityId: router.query.ProductId,
                                        start: router.query.start,
                                        end: router.query.end,
                                        yetiskin: router.query.yetiskin,
                                        cocuk: router.query.cocuk,
                                        bebek: router.query.bebek,
                                        PromotionCode: localStorage.getItem("PromotionCode") ? localStorage.getItem("PromotionCode") : isAppWebView ? "MobilApp.1000" : "",
                                        pool_fee: router.query.buyPool,
                                        selectedServices: router.query.selectedServices,
                                        isAppWebView: isAppWebView ? 1 : 0
                                    }, values).then(function(response) {
                                        if (response.data.error) {
                                            react_toastify_esm/* toast.error */.Am.error(response.data.error);
                                        } else {
                                            var ref;
                                            criteo/* sendReservation */.v9(values.email, SqlDate(router.query.start), SqlDate(router.query.end), parseInt(router.query.yetiskin) + parseInt(router.query.cocuk), response.data.id, response.data.deposit_price);
                                            if ((ref = response.data) === null || ref === void 0 ? void 0 : ref.redirectTo) {
                                                router.push(response.data.redirectTo);
                                                return;
                                            }
                                            if (window.ReactNativeWebView) {
                                                window.ReactNativeWebView.postMessage(JSON.stringify({
                                                    type: "PAYMENT_SUCCESS",
                                                    reservationId: response.data.id
                                                }));
                                            }
                                            setTimeout(function() {
                                                router.push({
                                                    pathname: "/" + SuccessPage.url,
                                                    query: {
                                                        q: response.data.hash
                                                    }
                                                });
                                            }, 300);
                                        }
                                        actions.setSubmitting(false);
                                    }).catch(function(error) {
                                        react_toastify_esm/* toast.error */.Am.error(error.message);
                                        actions.setSubmitting(false);
                                    });
                                },
                                children: function(props) {
                                    var ref;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("form", {
                                        className: "mt-20",
                                        onSubmit: props.handleSubmit,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    !isAppWebView && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "hidden sm:block mb-10",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountBannerMobile/* default */.Z, {
                                                            src: "/images/discount-banner-mobile.png"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Reservation_Title, {
                                                        children: reservationSection1Title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "grid gap-2 mt-8 sm:grid-cols-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Reservation_TextInput, {
                                                                className: "w-full py-3 text-sm font-semibold outline-none peer",
                                                                placeholder: reservationFormNamePlaceholder,
                                                                name: "name",
                                                                isrequired: "required"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Reservation_TextInput, {
                                                                className: "w-full py-3 text-sm font-semibold outline-none peer",
                                                                placeholder: reservationFormEmailPlaceholder,
                                                                name: "email",
                                                                type: "email",
                                                                isrequired: "required"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneInput/* default */.Z, {
                                                                name: "phone",
                                                                validname: "phoneIsValid",
                                                                label: reservationFormPhonePlaceholder,
                                                                isrequired: "required"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneInput/* default */.Z, {
                                                                name: "phone2",
                                                                validname: "phoneIsValid2",
                                                                label: reservationFormPhonePlaceholder2
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Reservation_PaymentOptions, {
                                                reservationResult: reservationResult,
                                                paymentType: page === null || page === void 0 ? void 0 : (ref = page.Product) === null || ref === void 0 ? void 0 : ref.paymentType
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-11",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Reservation_Title, {
                                                        children: reservationSection3Title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-col mt-5 gap-x-3 sm:flex-row",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex flex-col flex-1 gap-y-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "flex items-center justify-between bg-white rounded-md px-11 pt-7 pb-9",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "flex flex-col",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: "mb-2 text-15 leading-[18px] mt-1",
                                                                                        children: reservationDamageDeposit
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                        className: "text-13 text-brand-gray-9 leading-[15px]",
                                                                                        children: reservationDamageDepositDescription
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "text-[15px]",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                                                                                    value: page.Product.hasar,
                                                                                    Symbol: page.Product.Symbol
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "flex items-center bg-white rounded-md px-11 pt-7 pb-9",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "flex flex-col",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "mb-2 text-15 leading-[18px] mt-1",
                                                                                    children: reservationCheckinCheckoutTime
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "flex gap-x-[18px]",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                            className: "font-semibold text-13 text-brand-gray-2",
                                                                                            children: [
                                                                                                reservationCheckinTime,
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                                                                    className: "text-sm not-italic text-brand-black-2",
                                                                                                    children: page.Product.giris_saat
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* default */.Z, {
                                                                                            name: "DatepickerMiddle"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                            className: "font-semibold text-13 text-brand-gray-2",
                                                                                            children: [
                                                                                                reservationCheckoutTime,
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                                                                    className: "text-sm not-italic text-brand-black-2",
                                                                                                    children: page.Product.cikis_saat
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "w-full mt-3 sm:mt-0 sm:w-[342px] lg:w-[240px] xl:w-[342px] bg-white rounded-md px-11 pt-8 pb-10",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "text-primary",
                                                                        children: inludedPrice
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                        className: "mt-3",
                                                                        children: page.Product.fiyata_dahil && page.Product.fiyata_dahil.map(function(v, i) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                className: "leading-6 text-13 text-brand-gray-9",
                                                                                children: v
                                                                            }, i);
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col items-center gap-2 mt-14 lg:items-start",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Contract/* default */.Z, {
                                                        name: "sozlesme",
                                                        text: contract1,
                                                        content: page.sozlesme.icerik
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Contract/* default */.Z, {
                                                        name: "kvkk",
                                                        text: contract2,
                                                        content: page.kvkk.icerik
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Reservation_SendBtn, {
                                                        reservationResult: reservationResult,
                                                        a: props
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                }
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Reservation_Index = (Index);

// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/ri/RiShieldCheckFill.js
var RiShieldCheckFill = __webpack_require__(31532);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fa/FaTimesCircle.js
var FaTimesCircle = __webpack_require__(44147);
// EXTERNAL MODULE: ./components/Pages/ProductCategory.js + 9 modules
var ProductCategory = __webpack_require__(1237);
;// CONCATENATED MODULE: ./components/Pages/Reservation/Success.js








var Success = function(param) {
    var isAppWebView = param.isAppWebView;
    var page = (0,react.useContext)(context/* StoreContext */.x).page;
    var ref = (0,TranslationContext/* useTranslation */.m)(), reservationSuccessPageTitle = ref.reservationSuccessPageTitle, reservationSuccessPageDescription = ref.reservationSuccessPageDescription, dear = ref.dear, reservationSuccessPageSuccessMessage = ref.reservationSuccessPageSuccessMessage, error = ref.error, reservationSucessPageMailSendedMessage = ref.reservationSucessPageMailSendedMessage;
    var ShowReservationSucessPageMailSendedMessage = true;
    if ((0,ProductCategory.getCookie)("user-link") == "1") {
        if (("," + (0,ProductCategory.getCookie)("ids") + ",").indexOf("," + (page === null || page === void 0 ? void 0 : page.evid) + ",") > -1) {
            ShowReservationSucessPageMailSendedMessage = false;
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-brand-white bg-opacity-60 h-[calc(100vh-96px)] flex justify-center items-center px-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full lg:w-1/2 bg-white rounded-lg px-4 py-10 flex items-center flex-col",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton/* default */.Z, {
                    isAppWebView: isAppWebView
                }),
                page.error ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FaTimesCircle/* FaTimesCircle */.G, {
                            size: 96,
                            className: "text-red-500"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "font-bold text-lg text-red-500 mt-2",
                            children: error
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-sm text-brand-gray-2",
                            children: page.error
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RiShieldCheckFill/* RiShieldCheckFill */.e, {
                            size: 96,
                            className: "text-green-500"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "font-bold text-lg text-green-500 mt-2",
                            children: reservationSuccessPageTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-sm text-brand-gray-2",
                            dangerouslySetInnerHTML: {
                                __html: reservationSuccessPageDescription.replace("{id}", page.id)
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                            className: "h-0.25 bg-gray-100 w-full my-4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-sm text-brand-gray text-center leading-6",
                            children: [
                                dear,
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    className: "text-black font-extrabold",
                                    children: page.musteri
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                reservationSuccessPageSuccessMessage,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                ShowReservationSucessPageMailSendedMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    dangerouslySetInnerHTML: {
                                        __html: reservationSucessPageMailSendedMessage.replace("{mail}", page.email)
                                    }
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Reservation_Success = (Success);

;// CONCATENATED MODULE: ./components/Pages/Reservation.js




var Reservation = function(param) {
    var ssr = param.ssr, action = param.action, isAppWebView = param.isAppWebView;
    var comp = {
        Index: Reservation_Index,
        Success: Reservation_Success
    };
    var Component = comp[action];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
        page: ssr.result,
        isAppWebView: isAppWebView
    });
};
/* harmony default export */ var Pages_Reservation = (Reservation);


/***/ }),

/***/ 57736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Fancybox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92235);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82175);
/* harmony import */ var _react_icons_all_files_fa_FaCheck__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35229);
/* harmony import */ var _context_TranslationContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73040);
/* harmony import */ var react_dom_server__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97762);











var Contract = function(_param) {
    var text = _param.text, content = _param.content, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "text",
        "content"
    ]);
    var contractText = (0,_context_TranslationContext__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .m)().contractText;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,formik__WEBPACK_IMPORTED_MODULE_3__/* .useField */ .U$)(props), 3), field = ref[0], meta = ref[1], helpers = ref[2];
    var El = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            "data-fancybox": "dialog",
            "data-src": "#" + props.name + "-content",
            className: "font-bold",
            children: text
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Fancybox__WEBPACK_IMPORTED_MODULE_2__["default"], {
        options: {
            infinite: false
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative inline-block w-full sm:w-auto",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                        type: "checkbox"
                    }, props, field), {
                        id: props.name,
                        onChange: function(e) {
                            helpers.setValue(e.target.checked);
                        },
                        className: "w-0 h-0 absolute peer"
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                        htmlFor: props.name,
                        className: "text-13 text-black pl-7 py-2 cursor-pointer",
                        dangerouslySetInnerHTML: {
                            __html: contractText.replace(/\{contractName\}/g, (0,react_dom_server__WEBPACK_IMPORTED_MODULE_5__/* .renderToString */ .Dq)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(El, {})))
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "w-5 h-5 pointer-events-none rounded-sm border-2 transition-colors border-brand-gray-8 absolute left-0 top-0 mt-1 peer-checked:bg-brand-gray-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fa_FaCheck__WEBPACK_IMPORTED_MODULE_10__/* .FaCheck */ .l, {
                        size: 12,
                        className: "absolute left-1 top-2 opacity-0 peer-checked:opacity-100 pointer-events-none"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: props.name + "-content",
                className: "hidden max-w-[90%] break-words",
                dangerouslySetInnerHTML: {
                    __html: content
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Contract);


/***/ })

}]);